'use strict';

/* ── GENERIC PARALLAX (data-parallax) ── */
(function() {
  var els = Array.prototype.slice.call(document.querySelectorAll('[data-parallax]'));
  if (!els.length) return;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduce) return;
  var ticking = false;
  function update() {
    var vh = window.innerHeight;
    els.forEach(function(el) {
      var host = el.closest('section') || el.parentElement;
      var rect = host.getBoundingClientRect();
      if (rect.bottom < 0 || rect.top > vh) return;
      var speed = parseFloat(el.getAttribute('data-parallax')) || 0.15;
      var progress = (rect.top + rect.height / 2 - vh / 2);
      el.style.transform = 'translateY(' + (-progress * speed) + 'px)';
    });
    ticking = false;
  }
  window.addEventListener('scroll', function() {
    if (!ticking) { window.requestAnimationFrame(update); ticking = true; }
  }, { passive: true });
  window.addEventListener('resize', update, { passive: true });
  update();
})();

/* ── NEWSLETTER MODAL ── */
function openNewsletter() {
  var m = document.getElementById('nl-modal');
  if (!m) return;
  m.classList.add('open');
  m.setAttribute('aria-hidden', 'false');
  var input = document.getElementById('nl-email');
  var success = m.querySelector('.nl-success');
  setTimeout(function() { var t = success || input || m; if (t && t.focus) t.focus(); }, 60);
}
function closeNewsletter() {
  var m = document.getElementById('nl-modal');
  if (!m) return;
  m.classList.remove('open');
  m.setAttribute('aria-hidden', 'true');
  var tab = document.getElementById('nl-tab');
  if (tab) tab.focus();
}
document.addEventListener('keydown', function(e) {
  if (e.key === 'Escape') {
    var m = document.getElementById('nl-modal');
    if (m && m.classList.contains('open')) closeNewsletter();
  }
});
window.addEventListener('load', function() {
  if (window.__nlAutoOpen) openNewsletter();
});

/* — STICKY ADD-TO-CART BAR (mobile PDP) — Claude — */
(function(){
  if(!document.body.classList.contains('template-product')) return;
    var form = document.querySelector('form[action="/cart/add"]');
      if(!form) return;
        var atc = Array.prototype.slice.call(form.querySelectorAll('button')).filter(function(b){ return /add to cart/i.test(b.textContent); })[0];
          if(!atc) return;
            var titleEl = document.querySelector('.pdp-title');
              var priceEl = document.querySelector('.pdp-price');
                var imgEl = document.querySelector('.pdp-card-img img') || document.querySelector('.pdp-card-img');
                  var title = titleEl ? titleEl.textContent.trim() : (document.title || 'This item');
                    var price = priceEl ? priceEl.textContent.trim() : '';
                      var imgSrc = imgEl && imgEl.tagName === 'IMG' ? imgEl.currentSrc || imgEl.src : '';
                        var bar = document.createElement('div');
                          bar.className = 'pdp-sticky';
                            bar.setAttribute('aria-hidden','true');
                              var thumb = imgSrc ? '<img class="pdp-sticky__img" src="' + imgSrc + '" alt="">' : '';
                                bar.innerHTML = thumb +
                                    '<div class="pdp-sticky__info"><span class="pdp-sticky__title">' + title + '</span><span class="pdp-sticky__price">' + price + '</span></div>' +
                                        '<button type="button" class="btn btn-p pdp-sticky__btn">Add to Cart</button>';
                                          document.body.appendChild(bar);
                                            bar.querySelector('.pdp-sticky__btn').addEventListener('click', function(){ atc.click(); });
                                              var shown = false;
                                                function setShown(v){ if(v===shown) return; shown=v; bar.classList.toggle('is-visible', v); bar.setAttribute('aria-hidden', v?'false':'true'); }
                                                  if('IntersectionObserver' in window){
                                                      var io = new IntersectionObserver(function(entries){ entries.forEach(function(en){ setShown(!en.isIntersecting); }); }, { rootMargin: '0px 0px -10px 0px' });
                                                          io.observe(atc);
                                                            } else {
                                                                window.addEventListener('scroll', function(){ var r = atc.getBoundingClientRect(); setShown(r.bottom < 0); }, { passive: true });
                                                                  }
                                                                  })();